import { render, staticRenderFns } from "./TileData.vue?vue&type=template&id=e979f9bc"
import script from "./TileData.vue?vue&type=script&lang=js"
export * from "./TileData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports